import "./Error.css"

interface ErrorProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

export default function Error({ children, className, style }: ErrorProps) {
  return (
    <p style={style} className={"error m-0 " + className}>
      {children}
    </p>
  )
}
